import {EMAIL_REGEXP_ALLOW_WILDCARD} from "./form";
import asdfgh from 'asdfgh';
import {CasinoPage, CasinoPageTab} from "../../http/protocol";
import {useEffect, useRef, useState} from "react";
import {deviceDetect} from "react-device-detect";
import {DeviceOS} from "../../contenful/types";
import {LoginStatus, VerifyPrincipalStatus} from "../../http/Types";
import {t} from "../../i18n";

export function ellipsisText(maxChars : number, text? : string) {
    if(!text) {
        return undefined;
    }
    if(text.length > maxChars) {
        return text.substr(0,maxChars) + "...";
    }
    return text;
}

export const toGrid =  <T,> (banners : T[], gridSize? : number) : T[][]=> {
    if(!gridSize) gridSize = 1;
    const grid : T[][] = [];
    let current = 0;
    for(let i = 0; i<banners.length; i++) {
        if(!grid[current]) grid.push([]);

        grid[current].push(banners[i]);

        if((i+1)%gridSize == 0) {
            current++;
        }
    }
    let fill = 0;
    if(banners.length % gridSize > 0) {
        fill = gridSize - (banners.length % gridSize);
    }
    if(fill > 0) {
        for(let i = 0; i < fill; i++) {
            grid[grid.length - 1].push(banners[i]);
        }
    }
    return grid;
}
export class Optional<E> {
    constructor(private o? : E) {
    }
    static of<E>(o : E) {
        return new Optional(o);
    }
    isEmpty() {
        return typeof this.o === undefined;
    }
    static empty<E>() : Optional<E>{
        return new Optional<E>(undefined);
    }
    get() : E | undefined {
        if(typeof this.o === undefined){
            throw new Error("Optional is empty");
        }
        return this.o;
    }
}
export const normalizePhone = (phone: string | undefined) => {
    if (phone != undefined  &&  !phone.startsWith("+")) {
        return "+" + phone;
    }
    return phone;
}

export const isEmpty = (str? : string) : boolean => {
    return typeof(str) == "undefined" || str.trim().length == 0;
}
export function isRedirectToVerifyPrincipal( loginStatus? : LoginStatus, verifyEmailStatus?: VerifyPrincipalStatus) {
    return  (loginStatus == LoginStatus.VERIFICATION_REQUIRED || verifyEmailStatus === VerifyPrincipalStatus.IN_PROGRESS || verifyEmailStatus === VerifyPrincipalStatus.READY);
}

export function toSEOFriendlyString(str? : string) {
    if(!str) {
        return "";
    }
    return str.toLocaleLowerCase().replaceAll(" ", "-");
}
export const isValid = function (value : string | undefined, min : number = 0, max = Number.MAX_VALUE) : boolean {
    if(min == 0 && !value) {
        return true;
    } else if(!value || value.trim().length < min || value.trim().length > max) {
        return false;
    } else {
        return true;
    }
}
export const goToLobby = (history : any, page? : CasinoPage, tab? : CasinoPageTab) => {

    let url = "";
    if(tab && page && page.defaultPage == false) {
        url = `/casino/page/${page.id}/${toSEOFriendlyString(page.name)}/${tab.id}/${toSEOFriendlyString(tab.name)}`;
    } else if(page && page.defaultPage == false) {
        url = `/casino/page/${page.id}/${toSEOFriendlyString(page.name)}`;
    } else if(tab) {
        url = `/casino/${tab.id}/${toSEOFriendlyString(tab.name)}`;
    } else {
        url = "/casino"
    }
    history.push(url);
}

export const isPasswordValid = function (value : string | undefined) : boolean {
    if(!value) return false;
    if(!isValid(value,8,100)) {
        return false;
    }
    let lower = /[a-z]/.test(value);
    let upper = /[A-Z]/.test(value)
    let number = /[0-9]/.test(value);
    let email = matches(value,EMAIL_REGEXP_ALLOW_WILDCARD);

    console.log("lower = " + lower + ", upper = " + upper + ", number = " + number + ", email = " + email);

    return lower && upper && number && !email;
}
export const getDateAsNumber = (d : Date | number | undefined) => {
    if(d) {
        if(typeof(d) == "number") {
            return d;
        } else {
            return d.getTime();
        }
    }
    return undefined;
}
export const hasIllegalCharacters = (value : string | undefined) => {
    return matches(value, /[$;!"#€%&/()?<>\\+´']/);
}
export const matches = (value : string | undefined, exp : RegExp) : boolean => {
    if(!value) return false;
    return exp.test(value);
}

const checkPassphrase = (value : string | undefined) => new Promise((resolve, reject) => {
    let result = asdfgh(value)
    if(result) {
        resolve(result)
    }
    reject(new Error('Something went wrong'))
})

export const asyncValidate = (value : string | undefined) => {
  return checkPassphrase(value).then((res : any) => {
      if(res.score < 1) {
        throw { password : "Password is too weak" }
      }
  })
}

export const number = (value?: string) => value && isNaN(Number(value)) ? false : true;

export const isBot = (userAgent : string) => {
    return /googlebot|Prerender|bingbot|yandex|baiduspider|twitterbot|facebookexternalhit|facebookscraper|rogerbot|linkedinbot|embedly|quora link preview|showyoubot|outbrain|pinterest\/0\.|pinterestbot|slackbot|vkShare|W3C_Validator|whatsapp|Slackbot-LinkExpanding|Slack-ImgProxy|Slackbot|Discordbot|TelegramBot|WhatsApp/i.test(userAgent)
}

export const usePrevious = <T> (value : T) : T | undefined =>  {
    const ref = useRef<T>();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

export const isHomeScreen = () => {
    const homeScreen:boolean = (window.matchMedia('(display-mode: fullscreen)').matches || window.matchMedia('(display-mode: standalone)').matches);
    return homeScreen;
}
export const detectDeviceOS = () : DeviceOS  => {
    return deviceDetect(window.navigator.userAgent ? window.navigator.userAgent : "").os || deviceDetect(window.navigator.userAgent ? window.navigator.userAgent : "").osName || "unknown";
}

export default function useOnScreen(ref : any) {

    const [isIntersecting, setIntersecting] = useState(false)

    const observer = new IntersectionObserver(
        ([entry]) => setIntersecting(entry.isIntersecting)
    )

    useEffect(() => {
        observer.observe(ref.current)
        // Remove the observer as soon as the component is unmounted
        return () => { observer.disconnect() }
    }, [])

    return isIntersecting;
}

export const localStorageKey = (key : string) =>  {

    return {
        get : () => localStorage.getItem(key),
        set : (value? :string) => {
            if(!value) {
                localStorage.removeItem(key);
            } else {
                localStorage.setItem(key,value);
            }
        },
        remove : () => sessionStorage.removeItem(key),
        exists : () => localStorage.getItem(key) != null
    }
}

export const sessionStorageKey = (key : string) =>  {

    return {
        get : () => sessionStorage.getItem(key),
        set : (value? :string) => {
            if(!value) {
                sessionStorage.removeItem(key);
            } else {
                sessionStorage.setItem(key,value);
            }
        },
        remove : () => sessionStorage.removeItem(key),
        exists : () => sessionStorage.getItem(key) != null
    }
}

export const selectText = (name : string) => {
    return {
        nameText : t("forms."+name+".label"),
        invalidText : t("forms."+name+".invalid"),
        helpText : t("forms."+name+".help", {}, "")
    }
}
export const checkboxText = (name : string) => {
    return {
        nameText : t("forms."+name+".label"),
        invalidText : t("forms."+name+".invalid")
    }
}

export const throttle = (func : Function, limit : number) => {
    let lastCall = 0;
    return (...args: any[]) => {
        const now = new Date().getTime();

        if ((now - lastCall) < limit) {
            return;
        }
        lastCall = now;
        return func(...args);
    };
};